// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Grid: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 36.7"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M23.4 20H1.6c-.6 0-1 .4-1 1v14.4c0 .6.4 1 1 1h21.8c.6 0 1-.4 1-1V21c0-.6-.4-1-1-1zm-20 13.7V22.8h18.2v10.9H3.4zm47-13.7H28.6c-.6 0-1 .4-1 1v14.4c0 .6.4 1 1 1h21.8c.6 0 1-.4 1-1V21c0-.6-.4-1-1-1zm-1.8 2.8v10.9H30.4V22.8h18.2zM23.4.4H1.6c-.6 0-1 .4-1 1v14.4c0 .6.4 1 1 1h21.8c.6 0 1-.4 1-1V1.4c0-.6-.4-1-1-1zm-20 13.7V3.2h18.2v10.9H3.4zM50.4.4H28.6c-.6 0-1 .4-1 1v14.4c0 .6.4 1 1 1h21.8c.6 0 1-.4 1-1V1.4c0-.6-.4-1-1-1zm-1.8 2.8v10.9H30.4V3.2h18.2z"/></svg>;
};

export default React.memo(Grid);
